/**
 * Dashboard Tour Steps
 */
export const dashboardTourSteps = [
  {
    target: '.dashboard_sidebar_color',
    content: 'This is the main navigation sidebar. Use it to access different sections of the application.',
    placement: 'right',
    disableBeacon: true,
  },
  {
    target: '[data-testid="THOSPITALVAL"]',
    content: 'Select your hospital or clinic location here.',
    placement: 'bottom',
  },
  {
    target: '[data-testid="TPATIENTVAL"]',
    content: 'Choose a patient from the dropdown to view their data and records.',
    placement: 'bottom',
  },
];

/**
 * Login Tour Steps
 */
export const loginTourSteps = [
  {
    target: '[data-testid="TGETLOGINUSER"]',
    content: 'Enter your username (usually your email address) to log in.',
    placement: 'bottom',
  },
  {
    target: '[data-testid="TGETLOGINID"]',
    content: 'Enter your password. Click the eye icon to show/hide your password.',
    placement: 'bottom',
  },
  {
    target: '[data-testid="TGETLOGINOTP"]',
    content: 'If you have two-factor authentication enabled, enter your OTP code here.',
    placement: 'bottom',
  },
];

/**
 * Device Registration Tour Steps
 */
export const deviceRegistrationTourSteps = [
  {
    target: 'form',
    content: 'Fill in all required device information. Fields marked with * are mandatory.',
    placement: 'top',
  },
  {
    target: 'button[type="submit"]',
    content: 'Click Register to save the device information. Make sure all fields are valid before submitting.',
    placement: 'top',
  },
];

/**
 * Patient Dashboard Tour Steps
 */
export const patientDashboardTourSteps = [
  {
    target: '.patient-dashboard-header',
    content: 'View patient summary information and key metrics here.',
    placement: 'bottom',
  },
  {
    target: '.patient-charts',
    content: 'Interactive charts show patient data trends over time. Hover over data points for details.',
    placement: 'top',
  },
];

/**
 * Profile Tour Steps
 */
export const profileTourSteps = [
  {
    target: '[data-testid="TPROFILE_CHANGEPASSWORD"]',
    content: 'Click here to change your password. You will be redirected to a secure page to update your credentials.',
    placement: 'top',
  },
];

/**
 * Get tour steps by name
 */
export const getTourSteps = (tourName) => {
  const tours = {
    dashboard: dashboardTourSteps,
    login: loginTourSteps,
    deviceRegistration: deviceRegistrationTourSteps,
    patientDashboard: patientDashboardTourSteps,
    profile: profileTourSteps,
  };

  return tours[tourName] || [];
};

